import { LOG_OUT, LOGIN_COMPLETE, LOGIN_ERROR, LOGIN_START } from "./constants";
import AuthenticationService from "../../services/authentication-service";

const initialState = {
	profile: AuthenticationService.getProfile() || {},
	isAuthenticated: AuthenticationService.isAuthenticated(),
	isLoading: false
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case LOGIN_START:
			return { ...state, isLoading: true };
		case LOGIN_COMPLETE:
			return {
				...state,
				profile: payload.profile,
				isLoading: false,
				isAuthenticated: true
			};
		case LOGIN_ERROR:
			return {
				...state,
				profile: {},
				isLoading: false,
				isAuthenticated: false
			};
		case LOG_OUT:
			return {
				...state,
				profile: {},
				isLoading: false,
				isAuthenticated: false
			};
		default:
			return state;
	}
};

export default reducer;
